import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProjectApprovalsRoute: InvariantJiraRoute = {
	name: 'classic-business-approvals',
	path: '/jira/core/projects/:projectKey/approvals',
	exact: true,
};
